module.exports = __webpack_public_path__ + "img/icon_success.4511a792.png";